'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'puzzle';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e443';
var svgPathData = 'M296 0l-8 0 0 80 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 72 64 0 0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16 80 0 0-200-216 0zm8 64l0-48 192 0 0 168-80 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-64 0 0-40 24 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-24 0zM8 64l-8 0 0 448 448 0 0-232-104 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-64 0 0-216-224 0zM216 80l0 200-48 0 0-24c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 24-72 0 0-200 200 0zM96 296l8 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 64 0 0 48-24 0c-22.1 0-40 17.9-40 40s17.9 40 40 40l24 0 0 72-200 0 0-200 80 0zM232 416l0-8-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-64 48 0 0 24c0 22.1 17.9 40 40 40s40-17.9 40-40l0-24 72 0 0 200-200 0 0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPuzzle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;